export default __webpack_public_path__ + "static/media/connect-02.ba528e31.png";